import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function Menus({ children }) {
  useInjectSaga({ key: 'menus', saga });
  useInjectReducer({ key: 'menus', reducer });

  return React.Children.only(children);
}

Menus.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withMenus } from './withMenus';
export { default as useMenus } from './useMenus';
export default compose(withConnect, memo)(Menus);
